<template>
  <Modal width="800" title="编辑人员任务权限" v-model="drawerOpened">
    <div class="userlist-wrapper">
      <div class="handle-wrapper">
        <div class="handle-left">
          <Input
            v-model="searchText"
            search
            placeholder="搜索用户..."
            @on-change="searchUser"
            clearable
            icon="ios-search"
            style="width: 200px;"
          >
          </Input>
        </div>
        <div class="handle-right">
          <span>共{{ totalRows }}条</span>
          <Page
            :total="totalRows"
            :page-size="15"
            @on-change="loadUser"
            show-total
            simple
            style="margin-right: 24px"
          />
        </div>
      </div>
      <Table size="small" :columns="taskCategoryColumns" :height="tableHeight"  border :data="userList">
        <template #checkBox="{ index, row, column }">
          <Icon type="md-checkbox" v-if="verifyTaskCategoryVisibleExistence(row, column)" color='green' size='22' class="check-box" @click="clickRoleCheckBox(index, column, false, row)"/>
          <Icon type="md-square-outline" v-else color='lightgray' size='22' class="check-box" @click="clickRoleCheckBox(index, column, true, row)"/>
        </template>

        <template #grayCheckBox="{ }">
          <Icon type="md-checkbox" color='gray' size='22' />
        </template>
      </Table>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "TaskCategoryDrawer",
  data() { 
    return {
      drawerOpened: false,
      page: 0,
      limit: 15,
      filterQuery: {
        showCount: true,
      },
      searchText: "",
      taskCategoryColumns: [
        {
          title: '人员',
          key: 'name',
          render: (h, params) => h("span", params.row.name)
        },
        {
          title: '销售',
          key: 'sales',
          slot: 'checkBox',
        },
        {
          title: '研发',
          key: 'research',
          slot: 'checkBox',
        },
        {
          title: '技服',
          key: 'techservice',
          slot: 'checkBox',
        },
        {
          title: '厂务',
          key: 'factory',
          slot: 'checkBox',
        },
        {
          title: '运输',
          key: 'shipping',
          slot: 'checkBox',
        },
        {
          title: '财务',
          key: 'fin',
          slot: 'checkBox',
        },
        {
          title: '总经办',
          key: 'office',
          slot: 'checkBox',
        },
      ],
      tableHeight: 400,
    }
  },
  computed: {
    ...mapState({
      userList: state => state.user.userList,
      totalRows: state => state.user.totalCounts,
    }),
  },
  methods: {
    ...mapActions({
      getUserList: "user/getUsersAction",
      updateUser: "user/updateUserAction",
    }),
    async openModal() {
      this.drawerOpened = true;
      await this.loadUser()
    },
    async loadUser(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText && this.searchText.trim() !== "") {
        this.filterQuery.userName = this.searchText;
      } else {
        delete this.filterQuery.userName;
      }
      try {
        await this.getUserList(this.filterQuery);
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
      }
    },
    async searchUser() {
      this.page = 0
      this.loadUser()
    },
    verifyTaskCategoryVisibleExistence(row, column) {
      if (row?.taskCategoryVisible.indexOf(column.key) > -1) {
        return true
      }
    },
    async clickRoleCheckBox(index, column, value, row) {
      const user = row
      if (value) {
        if (user.taskCategoryVisible) {
          user.taskCategoryVisible.push(column.key)
        } else {
          const taskCategoryVisible = []
          taskCategoryVisible.push(column.key)
          user.taskCategoryVisible = taskCategoryVisible
        }
      } else {
        const delTaskCategoryVisible = user.taskCategoryVisible.filter(x =>  x !== column.key)
        user.taskCategoryVisible = delTaskCategoryVisible
      }
      this.updateUser({
        id: row._id,
        data: { taskCategoryVisible: user.taskCategoryVisible }
      });
    },
  }
}
</script>

<style scoped lang="stylus">
.userlist-wrapper
  padding 10px
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

.handle-right
  display flex
  align-items center
  justify-content space-between
</style>